let currentZIndex = 3000;

export let getZIndex = (current?: number) => {
  if (current == currentZIndex) return currentZIndex;
  return ++currentZIndex;
};
